import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const dashboard: AppRouteModule = {
  path: '/dashboard',
  name: 'Dashboard',
  component: LAYOUT,
  redirect: '/dashboard/team',
  meta: {
    icon: 'ant-design:bar-chart-outlined',
    title: '数据看板',
    orderNo: 70,
    auth: 'board3d',
  },
  children: [
    {
      path: 'monthAchievement',
      name: 'DashboardAchievement',
      component: LAYOUT,
      meta: {
        title: '销售业绩看板',
        auth: 'board3d.index',
      },
      children: [
        {
          path: 'monthAchievement',
          name: 'DashboardMonthAchievement',
          component: () => import('/@/views/admin/dashboard/achievement/index.vue'),
          meta: {
            title: '团队业绩',
            ignoreKeepAlive: false,
            auth: 'board3d.teamachievement3d',
          },
        },
        {
          path: 'personalAchievement',
          name: 'DashboardPersonalAchievement',
          component: () => import('/@/views/admin/dashboard/achievement/personal.vue'),
          meta: {
            title: '客户经理业绩',
            ignoreKeepAlive: false,
            auth: 'board3d.personachievement3d',
          },
        },
        {
          path: 'holidayAchievement',
          name: 'DashboardHolidayAchievement',
          component: () => import('/@/views/admin/dashboard/achievement/holiday.vue'),
          meta: {
            title: '休假业绩',
            ignoreKeepAlive: false,
            auth: 'board3d.holidayachievement3d',
          },
        },
      ],
    },
    {
      path: 'sales',
      name: 'DashboardSales',
      component: () => import('/@/views/admin/dashboard/sales/index.vue'),
      meta: {
        title: '销售回款看板',
        ignoreKeepAlive: false,
        auth: 'board3d.salesreceipts3d',
      },
    },
    {
      path: 'team',
      name: 'DashboardT',
      component: LAYOUT,
      meta: {
        title: '销售分析看板',
        auth: 'board3d.index',
      },
      children: [
        {
          path: 'team',
          name: 'DashboardTeam',
          component: () => import('/@/views/admin/dashboard/team/index.vue'),
          meta: {
            title: '团队分析',
            ignoreKeepAlive: false,
            auth: 'board3d.teamboard3d',
          },
        },
        {
          path: 'recharge',
          name: 'DashboardRecharge',
          component: () => import('/@/views/admin/dashboard/recharge/index.vue'),
          meta: {
            title: '充值分析',
            ignoreKeepAlive: false,
            auth: 'board3d.rechargeanalysic',
          },
        },
        {
          path: 'industry',
          name: 'DashboardIndustry',
          component: () => import('/@/views/admin/dashboard/industry/index.vue'),
          meta: {
            title: '行业分析',
            ignoreKeepAlive: false,
            auth: 'board3d.industryanalysic',
          },
        },
        {
          path: 'material',
          name: 'DashboardMaterial',
          component: () => import('/@/views/admin/dashboard/material/index.vue'),
          meta: {
            title: '销售材料分析',
            ignoreKeepAlive: false,
            auth: 'board3d.materialsaleanalysic',
          },
        },
        {
          path: 'source',
          name: 'DashboardSource',
          component: () => import('/@/views/admin/dashboard/source/index.vue'),
          meta: {
            title: '客户来源分析',
            ignoreKeepAlive: false,
            auth: 'board3d.customersourceanalysic',
          },
        },
        {
          path: 'taobao',
          name: 'DashboardTB',
          component: () => import('/@/views/admin/dashboard/taobao/index.vue'),
          meta: {
            title: '淘宝客户分析',
            ignoreKeepAlive: false,
            auth: 'board3d.tbanalysic',
          },
        },
        {
          path: 'keyCustomer',
          name: 'DashboardKeyCustomer',
          component: () => import('/@/views/admin/dashboard/key-customer/index.vue'),
          meta: {
            title: '价值客户分析',
            ignoreKeepAlive: false,
            auth: 'board3d.keycustomeranalysic',
          },
        },
        {
          path: 'poster',
          name: 'DashboardPoster',
          component: () => import('/@/views/admin/dashboard/poster/index.vue'),
          meta: {
            title: '海报推荐看板',
            ignoreKeepAlive: false,
            auth: 'board3d.posteranalysic',
          },
        },
        {
          path: 'domesticOverview',
          name: 'DomesticOverview',
          component: () => import('/@/views/admin/dashboard/domestic-overview/index.vue'),
          meta: {
            title: '国内逾期看板',
            ignoreKeepAlive: false,
            auth: 'board3d.overview',
          },
        },
      ],
    },
    {
      path: 'retention',
      name: 'DashboardRetention',
      component: LAYOUT,
      meta: {
        title: '留存看板',
        auth: 'board3d.index',
      },
      children: [
        {
          path: 'index',
          name: 'RetentionTeam',
          component: () => import('/@/views/admin/dashboard/retention/index.vue'),
          meta: {
            title: '团队分析',
            ignoreKeepAlive: false,
            auth: 'board3d.retentionteam',
          },
        },
        {
          path: 'personal',
          name: 'RetentionPersonal',
          component: () => import('/@/views/admin/dashboard/retention/personal.vue'),
          meta: {
            title: '客户经理分析',
            ignoreKeepAlive: false,
            auth: 'board3d.retentionpersonal',
          },
        },
      ],
    },
    {
      path: 'afterSales',
      name: 'DashboardAfterSales',
      component: LAYOUT,
      meta: {
        title: '售后看板',
        auth: 'board3d.index',
      },
      children: [
        {
          path: 'afterSalesOrders',
          name: 'AfterSalesOrders',
          component: () => import('/@/views/admin/dashboard/after-sales/afterSalesOrders.vue'),
          meta: {
            title: '售后订单统计分析',
            ignoreKeepAlive: false,
            auth: 'board3d.aftersalesorders3d',
          },
        },
        {
          path: 'afterSalesApplication',
          name: 'AfterSalesApplication',
          component: () => import('/@/views/admin/dashboard/after-sales/afterSalesApplication.vue'),
          meta: {
            title: '售后申请单统计分析',
            ignoreKeepAlive: false,
            auth: 'board3d.aftersalesapplication3d',
          },
        },
      ],
    },
    {
      path: 'skaSales',
      name: 'DashboardSKASales',
      component: LAYOUT,
      meta: {
        title: 'SKA看板',
        auth: 'board3d.index',
      },
      children: [
        {
          path: 'inquiryConversion',
          name: 'InquiryConversion',
          component: () => import('/@/views/admin/dashboard/ska-sales/inquiryConversion.vue'),
          meta: {
            title: 'CNC询单转化统计',
            ignoreKeepAlive: false,
            auth: 'board3d.inquiryconversioncnc',
          },
        },
        {
          path: 'paymentCollection',
          name: 'PaymentCollection',
          component: () => import('/@/views/admin/dashboard/ska-sales/paymentCollection.vue'),
          meta: {
            title: '对账&回款统计',
            ignoreKeepAlive: false,
            auth: 'board3d.paymentcollection',
          },
        },
        {
          path: 'transitOrder',
          name: 'TransitOrder',
          component: () => import('/@/views/admin/dashboard/ska-sales/transitOrder.vue'),
          meta: {
            title: '在途订单情况统计',
            ignoreKeepAlive: false,
            auth: 'board3d.transitorder',
          },
        },
      ],
    },
    {
      path: 'clue',
      name: 'DashboardClue',
      component: LAYOUT,
      meta: {
        title: '商机线索看板',
        auth: 'board3d.index',
      },
      children: [
        {
          path: 'business',
          name: 'DashboardBusiness',
          component: () => import('/@/views/admin/dashboard/clue/business.vue'),
          meta: {
            title: '商机处理看板',
            ignoreKeepAlive: false,
            auth: 'board3d.businessanalysic',
          },
        },
        {
          path: 'businessAnalysic',
          name: 'DashboardBusinessAnalysic',
          component: () => import('/@/views/admin/dashboard/clue/businessAnalysic.vue'),
          meta: {
            title: '商机分析看板',
            ignoreKeepAlive: false,
            auth: 'board3d.businessanalysic',
          },
        },
        {
          path: 'leads',
          name: 'DashboardLeads',
          component: () => import('/@/views/admin/dashboard/clue/clue.vue'),
          meta: {
            title: '线索看板',
            ignoreKeepAlive: false,
            auth: 'board3d.leadsanalysic',
          },
        },
      ],
    },
    {
      path: 'agentQuote',
      name: 'DashboardAgentQuote',
      component: LAYOUT,
      meta: {
        title: '询价单看板',
        auth: 'board3d.index',
      },
      children: [
        {
          path: 'agentQuote',
          name: 'DashboardAgentQuoteOrder',
          component: () => import('/@/views/admin/dashboard/agent-quote/index.vue'),
          meta: {
            title: '订单转化率',
            ignoreKeepAlive: false,
            auth: 'board3d.agentquoteorderanalysic',
          },
        },
        {
          path: 'agentQuoteMaterial',
          name: 'DashboardAgentQuoteMaterial',
          component: () => import('/@/views/admin/dashboard/agent-quote/quote-material.vue'),
          meta: {
            title: '人工询价成交情况',
            ignoreKeepAlive: false,
            auth: 'board3d.agentquotematerialanalysic',
          },
        },
        {
          path: 'agentCloseAnalysic',
          name: 'DashboardAgentCloseAnalysic',
          component: () => import('/@/views/admin/dashboard/agent-quote/quote-close.vue'),
          meta: {
            title: '未成交原因分析',
            ignoreKeepAlive: false,
            auth: 'board3d.agentcloseanalysic',
          },
        },
      ],
    },
    {
      path: 'quote',
      name: 'DashboardQuote',
      component: LAYOUT,
      meta: {
        title: '后台报价看板',
        auth: 'board3d.index',
      },
      children: [
        {
          path: 'quote',
          name: 'DashboardQuoteOrder',
          component: () => import('/@/views/admin/dashboard/quote/index.vue'),
          meta: {
            title: '报价看板',
            ignoreKeepAlive: false,
            auth: 'board3d.quoteanalysic',
          },
        },
        {
          path: 'quoteMaterial',
          name: 'DashboardQuoteMaterial',
          component: () => import('/@/views/admin/dashboard/quote/quote-material.vue'),
          meta: {
            title: '报价材料看板',
            ignoreKeepAlive: false,
            auth: 'board3d.quoteanalysic',
          },
        },
      ],
    },
    {
      path: 'customerFollow',
      name: 'DashboardCustomerFollow',
      component: () => import('/@/views/admin/dashboard/customer-follow/index.vue'),
      meta: {
        title: '客户分类跟进看板',
        ignoreKeepAlive: false,
        auth: 'board3d.customerfollowanalysic',
      },
    },
    {
      path: 'salesTarget',
      name: 'DashboardTarget',
      component: () => import('/@/views/admin/dashboard/target/index.vue'),
      meta: {
        title: '销售目标',
        ignoreKeepAlive: false,
        auth: 'crm.achievement',
      },
    },
    {
      path: 'monthlyReview',
      name: 'DashboardMonthlyReview',
      component: () => import('/@/views/admin/dashboard/monthly/index.vue'),
      meta: {
        title: '月度复盘',
        ignoreKeepAlive: false,
        auth: 'board3d.monthlyreview',
      },
    },
  ],
};

export default dashboard;
